import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, createContext } from 'react';
export var FrameCount = /*#__PURE__*/createContext({
  frameCount: 0,
  setFrameCount: function setFrameCount() {}
});
var FrameCountProvider = function FrameCountProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    frameCount = _useState2[0],
    setFrameCount = _useState2[1];
  var value = {
    frameCount: frameCount,
    setFrameCount: setFrameCount
  };
  useEffect(function () {
    if (frameCount > 1) {
      throw new Error('Max limit of one frame component per module.');
    }
  }, [frameCount]);
  return /*#__PURE__*/React.createElement(FrameCount.Provider, {
    value: value
  }, children);
};
export default FrameCountProvider;